module.exports = __webpack_public_path__ + "img/14.d66132a4.jpg";